import * as React from 'react';
import Layout from '../layout';
import { SortWrapper, SortMessage, SortTitle, SortSubtitle, Sep, SortContent, SortFormContainer, SortForm, InputField, InputGroup, ButtonGroup, InputInfoIcon, InputInfo } from './styled';
import { Button } from '../../widgets/globaleStyledWidget';
import { colors } from '../../variables';

import {FormattedMessage} from 'react-intl';



const SortPage:React.FunctionComponent = () => {

    /* Info Input Number */
    const [InfoNumberActive, setInfoNumberActive] = React.useState<boolean>(false);
    const openNumberInfo = () => { setInfoNumberActive(true); }
    const closeNumberInfo = () => { setInfoNumberActive(false); }

    /* Info Input */
    const [InfoActive, setInfoActive] = React.useState<boolean>(false);
    const openInfo = () => { setInfoActive(true); }
    const closeInfo = () => { setInfoActive(false); }

    return <Layout>
      
      <SortWrapper>
        <SortContent>
          <SortTitle><FormattedMessage id="sort_txt_title1" defaultMessage=""/></SortTitle>
          <SortMessage><FormattedMessage id="sort_txt_text1" defaultMessage=""/></SortMessage>
          <ButtonGroup>
            <Button color={colors.main} hover="main"><FormattedMessage id="sort_txt_button1" defaultMessage=""/></Button>
          </ButtonGroup>
          <Sep/>
          <SortSubtitle><FormattedMessage id="sort_txt_title2" defaultMessage=""/></SortSubtitle>
          <SortMessage><FormattedMessage id="sort_txt_text2" defaultMessage=""/></SortMessage>
          <ButtonGroup>
            <Button color={colors.secondary} hover="secondary"><FormattedMessage id="sort_txt_button2" defaultMessage=""/></Button>
          </ButtonGroup>
        </SortContent>
      </SortWrapper>

    </Layout>;
}

export default SortPage;